import React from "react";
import { FaClock, FaBook, FaCheckCircle } from "react-icons/fa";
import { useTranslation } from "react-i18next"; // ✅ Import i18n
import "./CourseCard.css";

const getProgressClass = (progress) => {
  if (progress >= 80) return "green";
  if (progress >= 40) return "yellow";
  return "red";
};

const CourseCard = ({ course, onClick }) => {

  const { t, i18n } = useTranslation(); // ✅ add i18n

  if (!course) return null;

  const progress = course.progress || 0;
  console.log("📘 Course Data:", course);

  return (
    <div className="course-card" onClick={() => onClick(course)}>
      <img
        src={`${course.image}`}
        alt={course.title}
        className="course-image"
      />
      <h5 className="course-title">
        {i18n.language === "ar" ? course.titleAr : course.title}
      </h5>

      <div className="course-details">
        <p><FaBook className="icon" /> {course.level}</p>
        <p><FaClock className="icon" /> {course.duration}</p>
        <p><FaCheckCircle className="icon" /> {course.classes} {t("Classes")}</p>
      </div>

      <div className={`progress-circle ${getProgressClass(progress)}`}>
        {progress}%
      </div>
    </div>
  );
};

export default CourseCard;
